import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/therapist/earnings")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/therapist/finances" });
  },
});
